const BASE_DOWNLOAD_TICKET_EVENT = {
    category: 'user_accounts',
    action: 'ticket_download',
    label: undefined,
    property: {},
    value: undefined,
};

function createDownloadTicketEvent({ orderId, ticketType }) {
    return {
        ...BASE_DOWNLOAD_TICKET_EVENT,
        label: ticketType,
        property: {
            orderId: orderId || null,
        },
    };
}

export default {
    createDownloadTicketEvent,
};
